'use client'

import { getMessages } from './messages'
import { useLocale } from './useLocale'

export function useMessages() {
  const locale = useLocale()

  return getMessages(locale)
}
